'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _defaults = require('./defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _retcode = require('./middlewares/retcode');

var _retcode2 = _interopRequireDefault(_retcode);

var _csrf = require('./middlewares/csrf');

var _csrf2 = _interopRequireDefault(_csrf);

var _redirect = require('./middlewares/redirect');

var _redirect2 = _interopRequireDefault(_redirect);

var _sessionExpire = require('./middlewares/sessionExpire');

var _sessionExpire2 = _interopRequireDefault(_sessionExpire);

var _mwManager = require('./mwManager');

var _mwManager2 = _interopRequireDefault(_mwManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreMiddlewares = [_retcode2.default, _csrf2.default, _redirect2.default, _sessionExpire2.default];

// 请求全局变量的设置
request.defaults = _defaults2.default;
request.middlewares = new _mwManager2.default();
coreMiddlewares.forEach(function (mw) {
  return request.middlewares.use(mw);
});

function _request(params) {
  var ctx = {
    req: {},
    res: {}
  };

  // 此处需要 defaults 做 deep merge
  var targetParams = Object.assign({}, _defaults2.default, params);
  var headers = Object.assign({}, _defaults2.default.headers, params.headers || {});
  var headerKeys = Object.keys(headers);
  targetParams.headers = {};
  // 过滤空字段
  for (var i = 0, len = headerKeys.length; i < len; i += 1) {
    var key = headerKeys[i];
    if (headers[key]) {
      targetParams.headers[key] = headers[key];
    }
  }

  ctx.req.params = targetParams;

  var promise = request.middlewares.run(ctx);
  // only return data
  return promise.then(function (context) {
    return context.res.data;
  });
}

// ajax-like style
function request(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var targetParams = {};

  // 合并参数，支持单参数和多参数
  if (typeof url === 'string') {
    Object.assign(targetParams, params, { url: url });
  } else {
    if (!url || !url.url) {
      throw new Error('url should be string');
    }
    Object.assign(targetParams, url);
  }

  return _request(targetParams);
}

// new style
['post', 'put', 'patch'].forEach(function (method) {
  request[method] = function (url, data, params) {
    var targetParams = {};
    if (typeof url !== 'string') {
      throw new Error('url should be string');
    }

    // 合并参数
    if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
      Object.assign(targetParams, params, { data: data, url: url, method: method });
    } else {
      Object.assign(targetParams, { data: data, url: url, method: method });
    }

    return _request(targetParams);
  };
});

['get', 'delete', 'options', 'head'].forEach(function (method) {
  request[method] = function (url, params) {
    if (typeof url !== 'string') {
      throw new Error('url should be string');
    }

    var targetParams = Object.assign({}, params, { url: url, method: method });
    return _request(targetParams);
  };
});

exports.default = request;